<template lang="html">
  <keep-alive>
    <div
      v-if="!message.notification"
      class="chat-message"
      :class="{
        self: message._id == myself,
        'no-margin-top': message.hide_name
      }"
    >
      <div class="container column">
        <span v-show="message._id != myself && !message.hide_name">{{ message.name }}</span>
        <audio-player v-if="message.is_media" :src="message.media_url" style="width: 250px;" :preDuration="message.media_duration"/>
        <pre v-else>{{ message.message }}</pre>
      </div>
    </div>
    <div
      v-else
      class="chat-notification"
      :class="[ message.notification_type ]"
    >
      <span>{{ message.message }}</span>
    </div>
  </keep-alive>
</template>

<script>
export default {
  name: 'chat-message',
  props: {
    myself: {
      type: String,
      required: true
    },
    message: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import './src/assets/css/base/variables';
.chat-message {
  display: inline-flex;
  margin: 5px;
  background-color: $color-blue-dark;
  padding: 6px 12px;
  align-self: flex-start;
  border-radius: 15px 15px 15px 0;
  &.self {
    align-self: flex-end;
    border-radius: 15px 15px 0 15px;
  }
  &.no-margin-top {
    margin-top: 0;
    border-radius: 0 15px 15px 0;
  }
  &.no-margin-top.self {
    border-radius: 15px 0 0 15px;
  }
  span {
    color: $color-purple;
  }
  pre {
    font-family: 'Volte', sans-serif;
    color: $color-white;
    white-space: pre-wrap;
    word-break: break-all;
  }
}

.chat-notification {
  padding: 5px 0;
  display: flex;
  justify-content: center;

  &.join {
    color: $color-purple;
  }
  &.leave {
    color: $color-grey-dark;
  }
  &.attention {
    color: $color-red;
    border-top: 2px solid $color-red;
    border-bottom: 2px solid $color-red;
  }
  &.disconnect {
    color: $color-red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChatBox/ChatMessage.vue